<template>
  <div>
    <PageTitle titleText="抽選結果"></PageTitle>
    <div class="c-allocationLottery__Wrap">
      <div class="c-allocationLottery__subTitle">
        {{ allocation ? allocation.name : "" }}
      </div>
      <div class="c-allocationLottery__aside">現在抽選を行っております</div>
      <div
        v-html="allocation ? allocation.lottery_text : ''"
        class="ck-content c-allocationLottery__content"
      ></div>
    </div>
    <el-button @click="onBack">戻る</el-button>
  </div>
</template>

<script>
import AllocationService from "@/services/allocation.service";
import PageTitle from "@/components/PageTitle.vue";
export default {
  name: "Lottery",
  components: {
    PageTitle,
  },
  data() {
    return {
      allocation: null,
    };
  },
  async mounted() {
    console.log("Lottery");
    const result = await AllocationService.find({
      where: {
        mansion: this.currentUser.mansion._id,
        "reception_range.0": { $lte: this.$date().toDate() },
        "reception_range.1": { $gte: this.$date().toDate() },
        status: "抽選中",
      },
    });
    if (result.data.length > 0) {
      this.allocation = result.data[0];
    }
    console.log("allocation", this.allocation);
  },
  methods: {
    onBack() {
      this.$router.push({ name: "allocation-index" });
    },
  },
};
</script>
